import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';
import { Command } from 'cmdk';

type CommandMenuEmptyProps = ComponentPropsWithoutRef<typeof Command.Empty>;

export const CommandMenuEmpty = forwardRef<ElementRef<typeof Command.Empty>, CommandMenuEmptyProps>(
  (props, ref) => <Command.Empty ref={ref} className="py-6 text-center text-sm" {...props} />,
);

CommandMenuEmpty.displayName = Command.Empty.displayName;
